import { TPrevSliceImages } from '../slices';
import { TypedRootState } from '../types';

export const selectPrevSliceImages = (state: TypedRootState): TPrevSliceImages => state.prevSliceImages;
